<mat-card>
  <div layout="row" layout-align="start center" class="pad-left-sm pad-right-sm">
    <span class="push-left-sm">
      <mat-card-title>Flight Log - {{ this.flightLog.logStatusDisplay }}</mat-card-title>
    </span>
    <span flex> </span>

    <fl-flight-log-action-buttons
      class="push-right-sm"
      [flightLog]="flightLog"
    ></fl-flight-log-action-buttons>
  </div>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div *ngIf="!isSimple" class="summary-section">
      <mat-chip-list>
        <mat-chip
          *ngFor="let crew of this.crewMembers"
          class="crewMember"
          [color]="colorFor(crew[2])"
        >
          <strong>{{ crew[0] }}:</strong>&nbsp;<em>{{ crew[1] }}</em>
        </mat-chip>
      </mat-chip-list>
      <mat-divider></mat-divider>
    </div>

    <div class="summary-section">
      <fl-view-flight-log-summary
        [flightSummary]="flightSummary"
        [flightLog]="flightLog"
      ></fl-view-flight-log-summary>
    </div>

    <div class="summary-section">
      <span>
        <strong>Flight Time: </strong
        >{{ statDisplay(this.flightLog.maintenanceSummary.totalFlightTime) }}
        hrs
      </span>
      <span>
        <strong>Total Landings: </strong
        >{{ statDisplay(this.flightLog.maintenanceSummary.totalLandings) }}</span
      >
    </div>

    <div id="card-container">
      <mat-card *ngFor="let entry of entries; let sequence = index" [ngClass]="entry.status">
        <mat-card-content>
          <h4>{{ sequence + 1 }}. {{ entry.entryDescription }}</h4>
          <div *ngIf="entry.logMode === 'EntryPerLeg'; else flightTime">
            <span class="leg-stat"> <strong>Departed: </strong> {{ entry.departureTime }}</span>
            <span class="leg-stat"> <strong>Arrived: </strong> {{ entry.arrivalTime }}</span>
          </div>
          <ng-template #flightTime>
            <div>
              <span class="leg-stat"> <strong>Flight Time: </strong> {{ entry.flightTime }} </span>
            </div>
          </ng-template>

          <div class="pilot-stats" *ngFor="let pilotEntry of entry.pilotEntries">
            <strong>{{ pilotEntry.pilot.firstName }} {{ pilotEntry.pilot.lastName }} :</strong>
            <em>Landings: </em>
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.landings.day)">
              <strong>Day: </strong>
              {{ statDisplay(pilotEntry.landings.day) }}</span
            >
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.landings.night)">
              <strong>Night: </strong>
              {{ statDisplay(pilotEntry.landings.night) }}</span
            >
            |
            <span *ngIf="hasStat(pilotEntry.hnvgo)">
              <span class="pilot-stat">
                <strong>HNVGO: </strong>
                {{ statDisplay(pilotEntry.hnvgo) }}</span
              >
              |
            </span>
            <em>Flight Hours: </em>
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.day)">
              <strong>Day: </strong>
              {{ statDisplay(pilotEntry.flightHours.day) }}</span
            >
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.nightUnaided)">
              <strong>Night: </strong>
              {{ statDisplay(pilotEntry.flightHours.nightUnaided) }}</span
            >
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.nightAided)">
              <strong>Night Aided: </strong>
              {{ statDisplay(pilotEntry.flightHours.nightAided) }}</span
            >
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.blockTime)">
              <strong>Block: </strong>
              {{ statDisplay(pilotEntry.flightHours.blockTime) }}</span
            >
            <ng-container *ngIf="features.part135part91">
              <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.part135)">
                <strong>Pt 135: </strong>
                {{ statDisplay(pilotEntry.flightHours.part135) }}</span
              >
              <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.part91)">
                <strong>Pt 91: </strong>
                {{ statDisplay(pilotEntry.flightHours.part91) }}</span
              >
            </ng-container>
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.ifrImc)">
              <strong>IFR: </strong>
              {{ statDisplay(pilotEntry.flightHours.ifrImc) }}</span
            >
            <span class="pilot-stat" *ngIf="hasStat(pilotEntry.flightHours.ifrSim)">
              <strong>IFR Sim: </strong>
              {{ statDisplay(pilotEntry.flightHours.ifrSim) }}</span
            >
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card-content>

  <mat-card-actions position="end">
    <button mat-button (click)="back()">Back</button>
  </mat-card-actions>
</mat-card>
